import styled from 'styled-components';

import { Text } from 'features/common/components/Text';

export const Title = styled(Text)`
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-weight: 600;
		font-size: 18px;
		line-height: 24px;
	}
`;

export const ReaderContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 15px;
`;

export const ModeSwitch = styled.div`
	display: flex;
	width: calc(100% - 32px);
	max-width: 560px;
	margin: 16px auto 0;
	padding: 3px;
	border: 1px solid #2e2e32;
	border-radius: 8px;
	background: #18181b;
	box-sizing: border-box;
`;

export const ModeButton = styled.button<{ $active: boolean }>`
	flex: 1;
	height: 40px;
	border: 1px solid ${({ $active }) => ($active ? '#3f3f46' : 'transparent')};
	border-radius: 6px;
	background: ${({ $active }) => ($active ? '#27272a' : 'transparent')};
	color: ${({ $active }) => ($active ? '#fafafa' : '#a1a1aa')};
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
`;
